var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('transition',{attrs:{"name":"page","mode":"out-in"}},[_c('keep-alive',[(_vm.$route.name == 'abonent_info_debtors')?_c('router-view'):_vm._e(),_c('DebtorsTable')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }